export const SINGULAR_EVENTS = {
  SCREEN_VIEW: 'screen_view',
  BANNER_CLICK: 'banner_click',
  CONTENT_SHARE: 'content_share',
  PROFILE_VIEW: 'profile_view',
  AVATAR_SELECTED: 'avatar_selected',
  CONTENT_CLICK: 'content_click',
  PAYWALL_VIEW: 'paywall_view',
  PAYWALL_CTA_CLICK: 'paywall_cta_click',
};

export const SINGULAR_SOCIAL_NETWORKS = {
  FACEBOOK: 'facebook',
  TWITTER: 'x',
  WHATSAPP: 'whatsapp',
};
